<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { canjearCupon } from '@frontend/promociones/services/promociones.api';
import { textos } from '@frontend/promociones/textos';

const route = useRoute();
const codigo = route.query['codigo'] as string;
const valido = ref(true);
const motivo = ref('');

onMounted(async () => {
  try {
    await canjearCupon(codigo);
  } catch (error: any) {
    valido.value = false;
    motivo.value = error.message;
  }
});
</script>

<template>
  <div class="flex min-h-screen items-center justify-center bg-[#f4f7ff] px-4">
    <div class="w-full max-w-sm rounded-2xl bg-white p-8 text-center shadow-md">
      <template v-if="valido">
        <div
          class="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-green-100"
        >
          <svg
            class="h-8 w-8 text-green-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h1 data-testid="cupon-valido" class="text-xl font-bold text-gray-900">
          {{ textos.cuponValido }}
        </h1>
      </template>
      <template v-else>
        <div
          class="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-red-100"
        >
          <svg
            class="h-8 w-8 text-red-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>
        <h1 data-testid="cupon-invalido" class="text-xl font-bold text-gray-900">
          {{ textos.cuponInvalido }}
        </h1>
        <p data-testid="motivo-cupon-invalido" class="mt-2 text-sm text-gray-500">
          {{ motivo }}
        </p>
      </template>
      <p data-testid="codigo-cupon" class="mt-6 text-xs text-gray-400">{{ codigo }}</p>
    </div>
  </div>
</template>
